import { render } from "./Center.vue?vue&type=template&id=e64f3b7c&scoped=true&ts=true"
import script from "./Center.vue?vue&type=script&lang=ts"
export * from "./Center.vue?vue&type=script&lang=ts"

import "./Center.vue?vue&type=style&index=0&id=e64f3b7c&lang=scss&scoped=true"

import exportComponent from "/home/appstore/appstore/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e64f3b7c"]])

export default __exports__